export default {
  de: {
    manifest_remove: 'Ressource entfernen',
    window_add: 'In Galerieansicht einblenden',
    window_remove: 'In Galerieansicht ausblenden',
  },
  en: {
    manifest_remove: 'Remove resource',
    window_add: 'Add to workspace',
    window_remove: 'Remove from workspace',
  },
  fr: {
    manifest_remove: 'Supprimer la ressource',
    window_add: 'Ajouter à l’espace de travail',
    window_remove: 'Retirer de l’espace de travail',
  },
};
